import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { ButtonComponent } from '@reconcept-platform/shared/ui/standalone/button';

@Component({
  selector: 'rcp-button-expandable-overlay-button',
  templateUrl: './button-expandable-overlay-button.component.html',
  styleUrls: ['./button-expandable-overlay-button.component.scss'],
  imports: [FontAwesomeModule, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonExpandableOverlayButtonComponent {
  @Input() disabled = false;
  @Input() active = false;
  @Input() icon: IconProp;
  @Input() iconRightRotate = true;

  faAngleDown = faAngleDown;
}
